import {isStartDateLessThanCurrentDate} from '@/helpers/dateUtils'
import {DATE_VALIDATION_MESSAGE} from '@/utils/constants/commonConstants'

export const useDatePickerValidation = (fieldName, validationRules = []) => {
  const validateStartDateAndEndDate = (selectedEndDate, selectedStartDate) => {
    const endDate = new Date(selectedEndDate)
    const startDate = new Date(selectedStartDate)

    endDate.setHours(0, 0, 0, 0)
    startDate.setHours(0, 0, 0, 0)

    const diffInMs = endDate - startDate
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24)

    return diffInDays
  }

  const validateSameMonth = selectedDate => {
    const today = new Date()
    const [month, day, year] = selectedDate.split('/').map(Number)
    const parsedSelectedDate = new Date(year, month - 1, day)

    return (
      parsedSelectedDate.getFullYear() === today.getFullYear() && parsedSelectedDate.getMonth() === today.getMonth()
    )
  }

  const validateDates = selectedDate => {
    const errorList = []
    const rules = [...validationRules]
    const label = fieldName

    rules.forEach(rule => {
      if (rule.type === 'required' && !selectedDate) {
        errorList.push(`${label}  ${rule.msg}`)
      }

      if (rule.type === 'startDate' && rule.endDate) {
        const startDateDiff = validateStartDateAndEndDate(selectedDate, rule.endDate)
        if (startDateDiff >= 0) {
          errorList.push(`${label}  ${DATE_VALIDATION_MESSAGE.CAN_NOT_BE_GREATOR_THAN_END_DATE}`)
        }
      }

      if (rule.type === 'pastValidation') {
        const errorMessage = `${label}  ${rule.msg}`
        
        if (isStartDateLessThanCurrentDate(selectedDate)) {
          errorList.push(errorMessage)
        }
      }

      if (rule.type === 'endDate' && rule.startDate) {
        const endDateDiff = validateStartDateAndEndDate(selectedDate, rule.startDate)
        if (endDateDiff <= 0) {
          errorList.push(`${label} ${DATE_VALIDATION_MESSAGE.MUST_BE_AFTER_START_DATE}`)
        }
      }

    })

    return errorList[0]
  }

  return {
    validateDates,
  }
}
